import { ENGLISH_IQ_STORED_SESSION_VERSION, SUPPORTED_LOCALES } from '@repo/config';
import {
  englishIqMilestoneSchema,
  englishIqResultSchema,
  englishIqStoredSessionSchema,
  type IEnglishIqStoredSession,
} from '@repo/sdk';
import { z } from 'zod';

const questionSessionSchema = englishIqStoredSessionSchema.extend({ milestone: z.null() });
const milestoneSessionSchema = englishIqStoredSessionSchema.extend({
  milestone: englishIqMilestoneSchema,
});
export const englishIqStoredFlowSchema = z.discriminatedUnion('phase', [
  z.object({ phase: z.literal('question'), session: questionSessionSchema }),
  z.object({ phase: z.literal('milestone'), session: milestoneSessionSchema }),
  z.object({
    expiresAt: z.number().int().positive(),
    locale: z.enum(SUPPORTED_LOCALES),
    phase: z.literal('completing'),
    startedAt: z.number().int().positive(),
    token: z.string().min(1),
    version: z.literal(ENGLISH_IQ_STORED_SESSION_VERSION),
  }),
  z.object({
    locale: z.enum(SUPPORTED_LOCALES),
    phase: z.literal('result'),
    result: englishIqResultSchema,
    version: z.literal(ENGLISH_IQ_STORED_SESSION_VERSION),
  }),
]);

export type IEnglishIqStoredFlow = z.infer<typeof englishIqStoredFlowSchema>;
export type { IEnglishIqStoredSession };
